import styled from "styled-components"

const DropZoneImg = styled.img`
  margin-right: ${(({theme}) => theme.spacing.two)};
  height: 60px;
`

export default DropZoneImg
